/* maligo® Konfigurator (allgemein) – ersetzt Easify. Daten: snippets/maligo-konfigurator.liquid
   Ablauf: Produkt (Jelly/Butter) → Größe bzw. Duft → Etikett → Logo → Menge → Warenkorb (+ Gratis-Probe).
   Links/oben: 3D-Vorschau der gewählten Dose mit Logo, daneben Fotos des Produkts. */
(() => {
  if (customElements.get('maligo-konfigurator')) return;

  // Produktwissen (CLAUDE.md)
  const FAMILIES = { J: ['J12', 'J30', 'J250'], B: ['B30', 'BP30'] };
  // Textur-Videos je Produktfamilie (Shopify-Dateien „4.mp4“ = Jelly, „86 - butter.mp4“ = Butter), als Vorschaubild nach 3D
  const VIDEO_CDN = 'https://cdn.shopify.com/videos/c/vp/';
  const VIDEOS = {
    J: { src: VIDEO_CDN + '2dba4b4f650a47bbbcb0e9af086b6ebe/2dba4b4f650a47bbbcb0e9af086b6ebe.SD-480p-1.2Mbps-61055207.mp4',
      poster: 'https://cdn.shopify.com/s/files/1/0978/4279/0745/files/preview_images/2dba4b4f650a47bbbcb0e9af086b6ebe.thumbnail.0000000000.jpg' },
    B: { src: VIDEO_CDN + '1027801a6aba467a93691cf57514834c/1027801a6aba467a93691cf57514834c.SD-480p-1.5Mbps-61052082.mp4',
      poster: 'https://cdn.shopify.com/s/files/1/0978/4279/0745/files/preview_images/1027801a6aba467a93691cf57514834c.thumbnail.0000000000.jpg' },
  };
  const familyOf = (type) => (type.startsWith('B') ? 'B' : 'J');
  const PER_TRAY = { J30: 24, B30: 27, BP30: 27 };
  // Produktionsangaben mit „_“: im Admin sichtbar, auf Rechnung (Sufio), Bestellmail und im Kundenkonto ausgeblendet (Maui 16.10.2026)
  const LID = (min) => ({ key: 'lid', prop: '_Logo Deckel', min });
  const UPLOADS = {
    J12: [LID(472)],
    J30: [LID(472), { key: 'front', prop: '_Logo Vorderseite', min: 638 }],
    J250: [LID(945), { key: 'side', prop: '_Logo Seitenetikett', min: 1181 }],
    B30: [LID(531)],
    BP30: [LID(531)]
  };
  // Hochgeladene Logos im Browser merken (IndexedDB, nur auf diesem Gerät), damit sie nach dem Neuladen noch da sind (Maui 17.10.2026).
  // Schlüssel = Etikett-Platz (lid/front/side), damit das Deckel-Logo auch beim Produktwechsel bleibt. Nach 30 Tagen vergessen.
  const LOGO_DB = { name: 'maligo-logos', store: 'files', days: 30 };
  function logoDb(version) {
    return new Promise((resolve, reject) => {
      if (!window.indexedDB) return reject(new Error('no idb'));
      const req = version ? indexedDB.open(LOGO_DB.name, version) : indexedDB.open(LOGO_DB.name);
      req.onupgradeneeded = () => {
        if (!req.result.objectStoreNames.contains(LOGO_DB.store)) req.result.createObjectStore(LOGO_DB.store);
      };
      req.onsuccess = () => {
        const db = req.result;
        if (db.objectStoreNames.contains(LOGO_DB.store)) return resolve(db);
        // Datenbank ohne Speicher (z. B. leer angelegt): Version erhöhen, damit er angelegt wird
        const next = db.version + 1;
        db.close();
        logoDb(next).then(resolve, reject);
      };
      req.onerror = () => reject(req.error);
    });
  }
  async function logoSave(key, file) {
    try {
      const db = await logoDb();
      db.transaction(LOGO_DB.store, 'readwrite').objectStore(LOGO_DB.store).put({ blob: file, name: file.name, type: file.type, ts: Date.now() }, key);
    } catch (e) { /* privates Fenster o. Ä.: dann eben nicht merken */ }
  }
  async function logoLoadAll() {
    try {
      const db = await logoDb();
      return await new Promise((resolve) => {
        const out = {};
        const st = db.transaction(LOGO_DB.store, 'readwrite').objectStore(LOGO_DB.store);
        const req = st.openCursor();
        req.onsuccess = () => {
          const cur = req.result;
          if (!cur) return resolve(out);
          const v = cur.value;
          if (v && v.blob && Date.now() - v.ts < LOGO_DB.days * 864e5) out[cur.key] = new File([v.blob], v.name, { type: v.type });
          else cur.delete();
          cur.continue();
        };
        req.onerror = () => resolve(out);
      });
    } catch (e) {
      return {};
    }
  }

  const LOGO_VALUES = {
    upload: 'Neues Logo hochgeladen',
    later: 'Logo folgt per E-Mail an print@maligotattoo.com',
    reuse: 'Wie letzte Bestellung'
  };
  const LABEL_ORDER = ['ORI', 'RAI', 'GLD', 'DIY'];
  // Produktfotos je Etikett, erkannt am Alt-Text (z. B. "30ml – With Tray (OJ)" oder "Original")
  // WhatsApp-Symbol für die Hilfe-Links (17.10.2026)
  const WA_ICON = '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true"><path fill="currentColor" d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Zm0 18.2c-1.5 0-3-.4-4.3-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2Zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.7 11.8 11.8 0 0 0 4.5 4c1.7.7 2.3.8 3.2.6.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2-.1-.1-.3-.2-.6-.3Z"/></svg>';
  // Haltbarkeit nach dem Öffnen in Monaten (FAQ-Texte 14.10.2026: Butter 6, Jelly 12; Pure laut CPSR 6)
  const PAO = { J: 12, B: 6, BP: 6 };
  // Etiketten in echt: Kundenfotos von der Website (Original, Rainbow, Gold), Clear/DIY als Produktfoto
  const LABEL_PHOTOS = [
    ['ORI', 'IMG_5562_d89af119-ab05-4a70-9d66-545e48cfe552.jpg', '50% 50%'], // Atelier Hannibal
    ['RAI', 'maligo-studio-21.jpg', '50% 55%'], // Juicy Ink
    ['GLD', 'maligo-studio-26.jpg', '50% 80%'], // OMT
    ['DIY', 'etikett-clear-foto.jpg', '50% 50%'] // offenes Tray, Dosen ohne Etikett (Foto Maui 17.10.2026)
  ];
  const LABEL_ALT = {
    ORI: /\(O[JB]\)|^original/i,
    RAI: /\(R[JB]\)|^rainbow/i,
    GLD: /\(G[JB]\)|^gold/i,
    DIY: /\(C[JB]\)|^clear/i
  };
  // Druckvorlagen (PDF: Anleitung + Vorlage mit Beschnitt, Schnitt, sicherem Bereich) je Dose, liegen in den Shopify-Dateien.
  // Quelle: 02-produkte/druckvorlagen/build_druckvorlage.py. TPL_V nach jedem Austausch erhöhen (sonst liefert das CDN die alte Datei).
  const CDN = 'https://cdn.shopify.com/s/files/1/0978/4279/0745/files/';
  const TPL_V = '20261017';
  // Alle 11 Shop-Sprachen; 30/250 ml DE heißen im Shop aus historischen Gründen „…_Top_Front_DE.pdf“
  const TPL_LANGS = ['de', 'en', 'fr', 'nl', 'it', 'es', 'pt', 'pl', 'sv', 'da', 'el'];
  const TPL_BASE = { J12: 'maligo_12ml_Jelly', J30: 'maligo_30ml_Jelly', J250: 'maligo_250ml_Jelly', B30: 'maligo_30ml_Butter', BP30: 'maligo_30ml_Butter' }; // Pure = gleiche Alu-Dose wie Butter
  const TEMPLATES = Object.fromEntries(Object.entries(TPL_BASE).map(([k, base]) => [k, Object.fromEntries(TPL_LANGS.map((l) =>
    [l, base + (l === 'de' && (k === 'J30' || k === 'J250') ? '_Top_Front_DE' : '_' + l.toUpperCase()) + '.pdf']))]));
  // Werbe-Kit (Aufsteller + Studio-Tester): Fotos je Textur, Aufsteller je Sprache
  const KIT = {
    J: { steher: { de: 'maligo-werbekit-steher-jelly-de.png', en: 'Steher_Jelly_EN.png', fr: 'Steher_Jelly_FR.png' }, tester: 'tester.jpg' },
    B: { steher: { de: 'Steher_Butter_DE_c9625fed-3024-467d-a1b8-d2fda2e9b151.png', en: 'Steher_Butter_EN.png', fr: 'Steher_Butter_FR.png' }, tester: 'tester_butter_6fcd140c-efde-44bf-a887-67a50985d939.png' }
  };
  // Lieferzeit in Werktagen (Mo–Fr) ab Eingang des Logos (es gibt keine Kunden-Freigabe, Maui 15.10.2026)
  const DELIVERY = { at: [10, 15], eu: [15, 20] };
  const addWorkdays = (from, n) => {
    const d = new Date(from);
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() % 6 !== 0) n--;
    }
    return d;
  };
  const PREORDER = 'BP30'; // Butter Pure: Voranmeldung (Klaviyo), solange es kein Produkt gibt

  const fill = (str, vars) => String(str).replace(/\{(\w+)\}/g, (_, k) => (k in vars ? vars[k] : `{${k}}`));
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  class MaligoKonfigurator extends HTMLElement {
    connectedCallback() {
      if (this.cfg) return;
      this.cfg = JSON.parse(this.querySelector('[data-mk-config]').textContent);
      this.t = this.cfg.t;
      this.money = new Intl.NumberFormat(this.cfg.locale, { style: 'currency', currency: this.cfg.currency });
      this.state = { type: null, label: 'ORI', units: null, logo: null, files: {}, images: {} };
      this.render();
      this.setType(this.cfg.current, true);
      this.applySharedLink();
      this.setupViewer();
      this.restoreLogos();
    }

    // gemerkte Logos zurückholen; „Neues Logo hochladen“ vorwählen, wenn noch nichts gewählt ist
    async restoreLogos() {
      const saved = await logoLoadAll();
      const keys = Object.keys(saved).filter((k) => !this.state.files[k]);
      if (!keys.length) return;
      keys.forEach((k) => (this.state.files[k] = saved[k]));
      if (!this.state.logo && this.state.label !== 'DIY') {
        this.state.logo = 'upload';
        const radio = this.querySelector('input[name="mk-logo"][value="upload"]');
        if (radio) radio.checked = true;
      }
      this.renderUploads(); // prüft die Dateien und legt sie auf die 3D-Dose
      this.update();
    }

    /* ---------- Daten ---------- */
    product(type = this.state.type) {
      return this.cfg.products[type];
    }
    // was angezeigt wird (Titel, Fotos): bei der Pure-Voranmeldung die normale Butter
    shown() {
      return this.product() || this.product('B30');
    }
    isPreorder(type = this.state.type) {
      return type === PREORDER && !this.product(type) && Boolean(this.cfg.pureForm);
    }
    labels() {
      const p = this.product();
      return LABEL_ORDER.filter((l) => p && p.variants.some((v) => v.label === l));
    }
    tiers(label = this.state.label) {
      const p = this.product();
      return p ? p.variants.filter((v) => v.label === label).sort((a, b) => a.units - b.units) : [];
    }
    variant() {
      return this.tiers().find((v) => v.units === this.state.units);
    }
    fmt(cents) {
      return this.money.format(cents / 100);
    }
    // kleinste Menge einer Größe (über alle Etiketten)
    minUnits(type) {
      const p = this.product(type);
      return p && p.variants.length ? Math.min(...p.variants.map((v) => v.units)) : 0;
    }
    tierName(units, type = this.state.type) {
      const per = PER_TRAY[type];
      if (!per) return fill(this.t.units, { n: units });
      const trays = units / per;
      return `${trays === 1 ? this.t.tray_1 : fill(this.t.tray_n, { n: trays })} · ${fill(this.t.units, { n: units })}`;
    }
    extras(v) {
      const type = this.state.type;
      const per = PER_TRAY[type];
      const trays = per ? v.units / per : 0;
      const list = [];
      if (type === 'J12' || type === 'J30') list.push('x_probe_B');
      if (type === 'B30' || type === 'BP30') list.push('x_probe_J');
      if (v.label !== 'DIY') list.push('x_check');
      // Gratisversand ab 250 € gilt nicht für die Schweiz (Maui 08.10.2026): Schweizer Kund*innen sehen ihn gar nicht
      if (v.price >= 25000 && this.cfg.country !== 'CH') list.push('x_ship');
      if ((per && trays >= 3) || (type === 'J12' && v.units >= 90)) list.push('x_kit');
      // 3D-Vorschau ist seit 15.10.2026 für alle im Konfigurator (kein Bundle-Extra mehr)
      if (per && trays >= 5) list.push('x_repeat');
      return list;
    }
    savings(v) {
      const base = this.tiers(v.label)[0];
      return Math.round((base.price / base.units) * v.units - v.price);
    }
    savingsPct(v) {
      const base = this.tiers(v.label)[0];
      const full = (base.price / base.units) * v.units;
      return full > 0 ? Math.max(0, (full - v.price) / full) : 0;
    }
    pct(x) {
      return new Intl.NumberFormat(this.cfg.locale, { style: 'percent', maximumFractionDigits: 0 }).format(x);
    }
    soldOut(type) {
      const p = this.product(type);
      return p && !p.variants.some((v) => v.available);
    }

    /* ---------- Grundgerüst ---------- */
    render() {
      const t = this.t;
      this.insertAdjacentHTML('beforeend', `
        <div class="mk__layout">
          <div class="mk__visual">
            <div class="mk__stage">
              <div class="mk__viewer" data-mk-viewer>
                <span class="mk__viewer-hint" data-mk-viewer-hint>${esc(t.viewer_loading)}</span>
                <span class="mk__swipe" data-mk-swipe aria-hidden="true"><span class="mk__swipe-arrow">‹</span><span class="mk__swipe-mid"><span class="mk__swipe-arrow mk__swipe-arrow--up">‹</span><span class="mk__swipe-hand"><svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true"><path fill="currentColor" d="M18.19 12.44l-3.24-1.62c1.29-1 2.12-2.56 2.12-4.32 0-3.03-2.47-5.5-5.5-5.5s-5.5 2.47-5.5 5.5c0 2.13 1.22 3.98 3 4.89v3.26c-2.15-.46-2.02-.44-2.26-.44-.53 0-1.03.21-1.41.59L4 16.22l5.09 5.09c.43.44 1.03.69 1.65.69h6.3c.98 0 1.81-.7 1.97-1.67l.8-4.71c.22-1.3-.43-2.58-1.62-3.18zM17.84 15.29L17.04 20h-6.3c-.09 0-.17-.04-.24-.1l-3.68-3.68 4.25.89V6.5c0-.28.22-.5.5-.5s.5.22.5.5v6h1.76l3.46 1.73c.4.2.62.63.55 1.06zM8.07 9.94c-.67-.58-1.1-1.42-1.1-2.37 0-1.73 1.4-3.13 3.13-3.13s3.13 1.4 3.13 3.13c0 .95-.43 1.79-1.1 2.37V6.5c0-1.38-1.12-2.5-2.5-2.5S8.07 5.12 8.07 6.5v3.44z"/></svg></span><span class="mk__swipe-arrow mk__swipe-arrow--down">‹</span></span><span class="mk__swipe-arrow">›</span></span>
                <div class="mk__views" role="group" data-mk-views hidden></div>
              </div>
              <img class="mk__photo" data-mk-photo alt="" hidden>
              <video class="mk__photo mk__video" data-mk-video muted loop playsinline preload="none" hidden></video>
              <button type="button" class="mk__share" data-mk-share aria-label="${esc(t.share)}">
                <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M12 3v12M7 8l5-5 5 5M5 13v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                <span>${esc(t.share)}</span>
              </button>
            </div>
            <div class="mk__media-bar">
              <div class="mk__thumbs" data-mk-thumbs></div>
            </div>
            <p class="mk__share-msg" data-mk-share-msg role="status" hidden></p>
          </div>

          <div class="mk__panel">
            <h1 class="mk__title" data-mk-title></h1>
            <a class="mk__rating" data-mk-rating href="#shopify-section-reviews" hidden></a>
            <p class="mk__anchor" data-mk-anchor></p>
            <p class="mk__subtitle">${esc(t.subtitle)}</p>

            <!-- Schritt 1 + 2 als Zusammenfassungs-Karte: zu, sobald gewählt; „Ändern“ klappt weich auf -->
            <div class="mk__pick" data-mk-sum>
              <button type="button" class="mk__pick-card" data-mk-sum-toggle aria-expanded="false" aria-controls="mk-pick-body">
                <img class="mk__pick-img" data-mk-sum-img alt="" width="56" height="56">
                <span class="mk__pick-text">
                  <span class="mk__pick-label">${esc(t.pick_label)}</span>
                  <span class="mk__pick-name" data-mk-sum-name></span>
                  <span class="mk__pick-desc" data-mk-sum-desc></span>
                </span>
                <span class="mk__pick-edit" data-mk-sum-edit>${esc(t.pick_edit)}</span>
              </button>
              <div class="mk__pick-body" id="mk-pick-body" data-mk-sum-body>
                <div class="mk__pick-inner">
                  <div class="mk__step">
                    <p class="mk__step-title">${esc(t.step_product)}</p>
                    <div class="mk__cards" role="radiogroup" aria-label="${esc(t.step_product)}" data-mk-families></div>
                    ${this.cfg.compareUrl ? `<a class="mk__compare" href="${esc(this.cfg.compareUrl)}" target="_blank" rel="noopener">${esc(t.compare)} <span aria-hidden="true">→</span></a>` : ''}
                  </div>
                  <div class="mk__step" data-mk-size-step>
                    <p class="mk__step-title" data-mk-size-title></p>
                    <div class="mk__chips" role="radiogroup" data-mk-sizes></div>
                  </div>
                  <div class="mk__ingr" data-mk-ingr></div>
                </div>
              </div>
            </div>

            <div class="mk__pure" data-mk-pure hidden>
              <div data-mk-pure-slot></div>
            </div>

            <div data-mk-buy>
            <div class="mk__step">
              <p class="mk__step-title"><span class="mk__num">1</span>${esc(t.step_label)}</p>
              <div class="mk__labels" role="radiogroup" aria-label="${esc(t.step_label)}" data-mk-labels></div>
              <p class="mk__desc" data-mk-desc></p>
              <button type="button" class="mk__kit-link mk__labels-link" data-mk-labels-open>${esc(t.labels_link)}</button>
              <p class="mk__note mk__resp" data-mk-resp>${esc(t.resp_note)}</p>
              <p class="mk__help" data-mk-diy-help hidden>${esc(t.diy_help)} <a href="${esc(this.cfg.whatsapp)}" target="_blank" rel="noopener">${WA_ICON}${esc(t.wa_ask)}</a></p>
              <a class="mk__template" data-mk-template href="#" target="_blank" rel="noopener" download>
                <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M12 4v11M7 10l5 5 5-5M5 20h14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                <span data-mk-template-text></span>
              </a>
            </div>

            <div class="mk__step" data-mk-logo-step>
              <p class="mk__step-title"><span class="mk__num">2</span>${esc(t.step_logo)}</p>
              <div class="mk__choices" role="radiogroup" aria-label="${esc(t.step_logo)}">
                ${['upload', 'later', 'reuse'].map((k) => `
                  <label class="mk__choice">
                    <input type="radio" name="mk-logo" value="${k}">
                    <span>${esc(t['logo_' + k])}</span>
                  </label>`).join('')}
              </div>
              <p class="mk__note mk__later-hint" data-mk-later-hint hidden></p>
              <div class="mk__uploads" data-mk-uploads hidden></div>
              <div class="mk__save" data-mk-save hidden>
                <button type="button" class="mk__save-open" data-mk-save-open aria-expanded="false"><svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M3 6h18v12H3z M3 7l9 6 9-6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg><span>${esc(t.save_btn)}</span></button>
                <form class="mk__save-form" data-mk-save-form hidden novalidate>
                  <p class="mk__save-title">${esc(t.save_title)}</p>
                  <p class="mk__note">${esc(t.save_text)}</p>
                  <input class="mk__save-email" type="email" required autocomplete="email" inputmode="email" placeholder="${esc(t.save_email)}" aria-label="${esc(t.save_email)}" data-mk-save-email>
                  <input class="mk__hp" type="text" tabindex="-1" autocomplete="off" aria-hidden="true" data-mk-save-hp>
                  <label class="mk__check"><input type="checkbox" data-mk-save-news> <span>${esc(t.save_news)}</span></label>
                  <p class="mk__save-privacy">${esc(t.save_privacy)} <a href="${esc(this.cfg.privacyUrl || '#')}" target="_blank" rel="noopener">${esc(t.save_privacy_link)}</a></p>
                  <button type="submit" class="mk__atc mk__save-submit" data-mk-save-submit>${esc(t.save_submit)}</button>
                  <p class="mk__save-msg" data-mk-save-msg role="status" hidden></p>
                </form>
              </div>
              <p class="mk__help">${esc(t.logo_help)} <a href="${esc(this.cfg.whatsapp)}" target="_blank" rel="noopener">${WA_ICON}${esc(t.wa_ask)}</a></p>
              <div data-mk-tpl-slot-logo></div>
            </div>

            <div class="mk__step">
              <p class="mk__step-title"><span class="mk__num" data-mk-num-qty>3</span>${esc(t.step_qty)}</p>
              <p class="mk__qty-hint" data-mk-qty-hint></p>
              <div class="mk__tiers" role="radiogroup" aria-label="${esc(t.step_qty)}" data-mk-tiers></div>
              <div class="mk__extras" data-mk-extras></div>
              <button type="button" class="mk__kit-link" data-mk-kit-open>${esc(t.kit_link)}</button>
              <details class="mk__calc">
                <summary>${esc(t.calc_title)}</summary>
                <label class="mk__calc-field">
                  <span>${esc(t.calc_label)}</span>
                  <span class="mk__calc-input"><input type="text" inputmode="decimal" autocomplete="off" data-mk-calc-price placeholder="0,00"><span data-mk-calc-cur></span></span>
                </label>
                <div class="mk__calc-out" data-mk-calc-out hidden>
                  <div><span>${esc(t.calc_cost)}</span><span data-mk-calc-cost></span></div>
                  <div class="is-strong"><span>${esc(t.calc_profit)}</span><span data-mk-calc-profit></span></div>
                  <div class="is-strong"><span data-mk-calc-total-label></span><span data-mk-calc-total></span></div>
                </div>
                <p class="mk__calc-note">${esc(t.calc_note)}</p>
              </details>
            </div>

            <div class="mk__featured">
              <p class="mk__featured-title"><span class="mk__featured-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" width="18" height="18"><rect x="3" y="3" width="18" height="18" rx="5" fill="none" stroke="currentColor" stroke-width="2"/><circle cx="12" cy="12" r="4" fill="none" stroke="currentColor" stroke-width="2"/><circle cx="17.5" cy="6.5" r="1.2" fill="currentColor"/></svg>
              </span>${esc(t.featured_title)}</p>
              <label class="mk__check"><input type="checkbox" data-mk-featured> <span>${esc(t.featured_check)}</span></label>
              <label class="mk__field" data-mk-insta-field hidden>
                <span>${esc(t.insta_label)}</span>
                <input type="text" data-mk-insta placeholder="@studio" autocomplete="off">
              </label>
            </div>

            <div class="mk__summary">
              <div class="mk__total"><span>${esc(t.total)}</span><strong data-mk-total></strong></div>
              <div class="mk__total-row"><span data-mk-total-sub></span><span>${esc(t.vat)}</span></div>
              <div class="mk__total-row mk__total-save" data-mk-total-save hidden><span data-mk-save-text></span><span data-mk-was></span></div>
              <p class="mk__vat-uid" data-mk-vat-uid hidden>${esc(t.vat_uid)}</p>
              <p class="mk__note mk__eta" data-mk-eta></p>
              <button type="button" class="mk__atc" data-mk-atc></button>
              <p class="mk__error" data-mk-error role="alert" hidden></p>
              <a class="mk__sample-link" href="#maligo-sample">${esc(t.sample_link)}</a>
              <p class="mk__ask">${esc(t.help_q)} <a href="${esc(this.cfg.whatsapp)}" target="_blank" rel="noopener">${WA_ICON}${esc(t.wa_ask)}</a></p>
            </div>


            </div>

            <ul class="mk__usps">
              <li>${esc(t.usp_2)}</li><li>${esc(t.usp_3)}</li>
            </ul>
            <div class="mk__payments">${(this.cfg.payments || []).join('')}</div>
          </div>
        </div>
        <dialog class="mk__kit" data-mk-kit aria-labelledby="mk-kit-title">
          <button type="button" class="mk__kit-close" data-mk-kit-close aria-label="${esc(t.close)}">×</button>
          <p class="mk__kit-title" id="mk-kit-title">${esc(t.kit_title)}</p>
          <p class="mk__kit-text">${esc(t.kit_text)}</p>
          <div class="mk__kit-imgs">
            <figure><img data-mk-kit-steher alt="${esc(t.kit_steher)}" loading="lazy"><figcaption>${esc(t.kit_steher)}</figcaption></figure>
            <figure><img data-mk-kit-tester alt="${esc(t.kit_tester)}" loading="lazy"><figcaption>${esc(t.kit_tester)}</figcaption></figure>
          </div>
          <p class="mk__kit-when">${esc(t.kit_when)}</p>
        </dialog>
        <dialog class="mk__kit mk__labels-dlg" data-mk-labels-dlg aria-labelledby="mk-labels-title">
          <button type="button" class="mk__kit-close" data-mk-labels-close aria-label="${esc(t.close)}">×</button>
          <p class="mk__kit-title" id="mk-labels-title">${esc(t.labels_title)}</p>
          <div class="mk__labels-grid">
            ${LABEL_PHOTOS.map(([l, f, pos]) => `
              <figure data-l="${l}"><img src="" data-src="${CDN}${f}?width=600" alt="${esc(t['label_' + l])}" loading="lazy" width="600" height="600" style="object-position:${pos}"><figcaption>${esc(t['label_' + l])}</figcaption></figure>`).join('')}
          </div>
          <p class="mk__kit-when">${esc(t.labels_note)}</p>
          <button type="button" class="mk__inci-ok" data-mk-labels-ok>${esc(t.close)}</button>
        </dialog>
        <dialog class="mk__kit mk__inci-dlg" data-mk-inci aria-labelledby="mk-inci-title">
          <button type="button" class="mk__kit-close" data-mk-inci-close aria-label="${esc(t.close)}">×</button>
          <p class="mk__kit-title" id="mk-inci-title">${esc(t.ingr_all)}</p>
          <p class="mk__inci-prod" data-mk-inci-prod></p>
          <p class="mk__inci-pao" data-mk-inci-pao></p>
          <div class="mk__inci-body" data-mk-inci-body></div>
          <button type="button" class="mk__inci-ok" data-mk-inci-ok>${esc(t.close)}</button>
        </dialog>
        <div class="mk__bar" data-mk-bar aria-hidden="true">
          <div class="mk__bar-total"><strong data-mk-bar-total></strong><span data-mk-bar-sub></span></div>
          <button type="button" class="mk__atc mk__atc--bar" data-mk-bar-btn tabindex="-1"></button>
        </div>`);

      // Klaviyo-Formular (steht schon im HTML) in den Pure-Bereich hängen
      const form = this.querySelector('[data-mk-pure-form]');
      if (form) this.querySelector('[data-mk-pure-slot]').append(form);

      this.querySelectorAll('input[name="mk-logo"]').forEach((el) =>
        el.addEventListener('change', () => this.setLogo(el.value)));
      // „Jetzt hochladen“ angeklickt (auch wenn es schon vorausgewählt ist): direkt zum ersten Upload-Feld springen (Maui 19.10.2026)
      this.querySelector('input[name="mk-logo"][value="upload"]')?.addEventListener('click', () => {
        requestAnimationFrame(() => this.querySelector('[data-mk-uploads] .mk__drop')?.scrollIntoView({ behavior: 'smooth', block: 'center' }));
      });
      this.querySelector('[data-mk-atc]').addEventListener('click', () => (this.missing() ? this.guide() : this.addToCart()));
      const featured = this.querySelector('[data-mk-featured]');
      featured.addEventListener('change', () => (this.querySelector('[data-mk-insta-field]').hidden = !featured.checked));
      this.querySelector('[data-mk-bar-btn]').addEventListener('click', () => this.barAction());
      this.querySelector('[data-mk-calc-price]').addEventListener('input', () => this.updateCalc());
      this.querySelector('[data-mk-calc-cur]').textContent = (this.money.formatToParts(0).find((p) => p.type === 'currency') || {}).value || '';
      const kit = this.querySelector('[data-mk-kit]');
      this.querySelector('[data-mk-kit-open]').addEventListener('click', () => this.openKit());
      this.querySelector('[data-mk-kit-close]').addEventListener('click', () => kit.close());
      kit.addEventListener('click', (e) => e.target === kit && kit.close()); // Klick auf den Hintergrund schließt
      this.querySelector('[data-mk-save-open]').addEventListener('click', () => {
        const f = this.querySelector('[data-mk-save-form]');
        f.hidden = !f.hidden;
        this.querySelector('[data-mk-save-open]').setAttribute('aria-expanded', String(!f.hidden));
        if (!f.hidden) this.querySelector('[data-mk-save-email]').focus();
      });
      this.querySelector('[data-mk-save-form]').addEventListener('submit', (e) => { e.preventDefault(); this.saveDesign(); });
      const ldlg = this.querySelector('[data-mk-labels-dlg]');
      this.querySelector('[data-mk-labels-open]').addEventListener('click', () => this.openLabels());
      this.querySelector('[data-mk-labels-close]').addEventListener('click', () => ldlg.close());
      this.querySelector('[data-mk-labels-ok]').addEventListener('click', () => ldlg.close());
      ldlg.addEventListener('click', (e) => e.target === ldlg && ldlg.close());
      const inci = this.querySelector('[data-mk-inci]');
      this.querySelector('[data-mk-inci-close]').addEventListener('click', () => inci.close());
      this.querySelector('[data-mk-inci-ok]').addEventListener('click', () => inci.close());
      inci.addEventListener('click', (e) => e.target === inci && inci.close());
      this.renderEta();
      this.querySelector('[data-mk-share]').addEventListener('click', () => this.share());
      this.querySelector('[data-mk-sum-toggle]').addEventListener('click', () => this.togglePick());
      // Zwei Modi (17.10.2026):
      // - schlank (Standard): Produkt + Größe sind schon gewählt (über Menü, Kollektion, Google, Werbung) → nur die Zeile
      //   „✓ Jelly · 12 ml … Ändern“, danach direkt Etikett, Logo, Menge. Rechner und Social-Media-Häkchen ausgeblendet.
      // - voll (?konfigurator=1, Knopf „Konfigurator starten“): Produkt + Größe offen, alles sichtbar.
      // Im vollen Modus klappen Schritt 1 + 2 zu, sobald im nächsten Abschnitt getippt wird (ohne Animation, mit Scroll-Ausgleich).
      this.full = new URLSearchParams(location.search).has('konfigurator');
      this.classList.toggle('mk--lite', !this.full);
      this.togglePick(this.full);
      const later = this.querySelector('[data-mk-buy]');
      const autoClose = (e) => {
        const box = this.querySelector('[data-mk-sum]');
        if (!box.classList.contains('is-open')) return;
        const anchor = e.target.closest('label, button, input, summary, a') || e.target;
        const before = anchor.getBoundingClientRect().top;
        box.classList.add('is-instant');
        this.togglePick(false);
        window.scrollBy(0, anchor.getBoundingClientRect().top - before);
        requestAnimationFrame(() => box.classList.remove('is-instant'));
      };
      later.addEventListener('pointerdown', autoClose);
      later.addEventListener('focusin', autoClose);
      this.setupBar();
      if (!this.id) this.id = 'mk-top';
    }

    /* ---------- Auswahl ---------- */
    setType(type, initial = false) {
      if (!this.product(type) && !this.isPreorder(type)) return;
      this.state.type = type;
      if (!this.isPreorder()) {
        const labels = this.labels();
        if (!labels.includes(this.state.label)) this.state.label = labels[0];
        const tiers = this.tiers();
        const keep = tiers.find((v) => v.units === this.state.units);
        this.state.units = (keep || tiers.find((v) => v.available) || tiers[0]).units;
      }
      if (!initial && this.product()) {
        const url = this.product().url + location.search;
        history.replaceState(history.state, '', url);
      }
      this.viewer?.setCan(type).then(() => this.applyLogos());
      this.renderChoices();
      this.renderUploads();
      this.renderThumbs();
      this.renderIngr();
      this.update();
    }

    // Schritt 1 + 2 auf-/zuklappen (open: true/false, sonst umschalten)
    togglePick(open) {
      const box = this.querySelector('[data-mk-sum]');
      const next = typeof open === 'boolean' ? open : !box.classList.contains('is-open');
      box.classList.toggle('is-open', next);
      this.querySelector('[data-mk-sum-toggle]').setAttribute('aria-expanded', String(next));
      this.querySelector('[data-mk-sum-edit]').textContent = next ? this.t.pick_done : this.t.pick_edit;
    }

    setFamily(fam) {
      if (familyOf(this.state.type) === fam) return;
      const options = FAMILIES[fam].filter((t) => this.product(t));
      const pick = options.find((t) => t === 'J30') || options.find((t) => !this.soldOut(t)) || options[0];
      if (pick) this.setType(pick);
    }

    setLabel(label) {
      const idx = this.tiers().findIndex((v) => v.units === this.state.units);
      this.state.label = label;
      const tiers = this.tiers();
      this.state.units = (tiers[idx] || tiers[0]).units;
      if (label === 'DIY') this.state.logo = null;
      this.viewer?.setStyle(label);
      this.renderChoices();
      this.renderUploads();
      this.renderThumbs();
      this.update();
    }

    setUnits(units) {
      this.state.units = units;
      this.update();
    }

    setLogo(choice) {
      this.state.logo = choice;
      this.renderUploads();
      this.update();
    }

    /* ---------- Darstellung der Auswahl ---------- */
    renderChoices() {
      const t = this.t;
      const type = this.state.type;
      const fam = familyOf(type);
      const p = this.shown();
      const preorder = this.isPreorder();

      // Zahl und Einheit nie trennen („30 ml“ mit geschütztem Leerzeichen)
      this.querySelector('[data-mk-title]').textContent = (preorder ? t.pure_title : p.title).replace(/(\d)\s+(ml|g|Stk\.?)/g, '$1 $2');
      const rating = this.querySelector('[data-mk-rating]');
      rating.hidden = !p.ratingCount || preorder;
      rating.innerHTML = p.ratingCount
        ? `<span class="mk__stars" style="--r:${Number(p.rating) || 0}">★★★★★</span> ${esc(fill(t.reviews, { n: p.ratingCount }))}`
        : '';
      rating.onclick = (e) => {
        const target = document.querySelector('[id$="__reviews"]');
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth' });
        }
      };

      // Produkt (Familie)
      const famBox = this.querySelector('[data-mk-families]');
      famBox.innerHTML = ['J', 'B'].map((f) => {
        const available = FAMILIES[f].some((x) => this.product(x));
        return `
          <label class="mk__card ${available ? '' : 'is-disabled'}">
            <input type="radio" name="mk-family" value="${f}" ${f === fam ? 'checked' : ''} ${available ? '' : 'disabled'}>
            <span class="mk__card-name">maligo® ${esc(t['fam_' + f])}</span>
            <span class="mk__card-desc">${esc(t['famdesc_' + f])}</span>
          </label>`;
      }).join('');
      famBox.querySelectorAll('input').forEach((el) => el.addEventListener('change', () => this.setFamily(el.value)));

      // Größe (Jelly) bzw. Duft (Butter)
      this.querySelector('[data-mk-size-title]').innerHTML = `${esc(fam === 'B' ? t.step_scent : t.step_size)}`;
      const sizes = this.querySelector('[data-mk-sizes]');
      sizes.style.gridTemplateColumns = `repeat(${FAMILIES[fam].length}, minmax(0, 1fr))`;
      sizes.innerHTML = FAMILIES[fam].map((x) => {
        const exists = Boolean(this.product(x)) || this.isPreorder(x);
        const note = this.isPreorder(x) ? `${t['sizedesc_' + x]} · ${t.soon}`
          : !exists ? t.soon : this.soldOut(x) ? t.sold_out : t['sizedesc_' + x];
        return `
          <label class="mk__chip ${exists ? '' : 'is-disabled'}">
            <input type="radio" name="mk-size" value="${x}" ${x === type ? 'checked' : ''} ${exists ? '' : 'disabled'}>
            <span class="mk__chip-name">${esc(t['size_' + x])}</span>
            <span class="mk__chip-desc">${esc(note)}</span>
            ${exists && !this.isPreorder(x) && this.minUnits(x) ? `<span class="mk__chip-units">${esc(fill(t.chip_units, { n: this.minUnits(x) }))}</span>` : ''}
          </label>`;
      }).join('');
      sizes.querySelectorAll('input').forEach((el) => el.addEventListener('change', () => this.setType(el.value)));

      // Zusammenfassungs-Karte (Schritt 1 + 2)
      const pickImg = this.photos()[0];
      const img = this.querySelector('[data-mk-sum-img]');
      img.hidden = !pickImg;
      if (pickImg) img.src = pickImg.thumb;
      this.querySelector('[data-mk-sum-name]').textContent = `${t['fam_' + fam]} · ${t['size_' + type]}`;
      this.querySelector('[data-mk-sum-desc]').textContent = this.isPreorder() ? `${t['sizedesc_' + type]} · ${t.soon}` : (t['sizedesc_' + type] || '');

      // Etikett
      const labelsBox = this.querySelector('[data-mk-labels]');
      labelsBox.innerHTML = this.labels().map((l) => `
        <label class="mk__label" data-l="${l}">
          <input type="radio" name="mk-label" value="${l}" ${l === this.state.label ? 'checked' : ''}>
          <span class="mk__swatch" style="background-image:url('${this.cfg.swatches[l]}')"></span>
          <span class="mk__label-name">${esc(t['label_' + l])}</span>
        </label>`).join('');
      labelsBox.querySelectorAll('input').forEach((el) => el.addEventListener('change', () => this.setLabel(el.value)));
      this.querySelector('[data-mk-desc]').textContent = t['desc_' + this.state.label];
    }

    // Fotos zum gewählten Etikett zuerst, dann neutrale Fotos (Textur); Fotos anderer Etiketten weglassen
    photos() {
      const all = this.shown().images;
      const tagOf = (img) => LABEL_ORDER.find((l) => LABEL_ALT[l].test(img.alt));
      const mine = all.filter((img) => tagOf(img) === this.state.label);
      const neutral = all.filter((img) => !tagOf(img));
      return this.isPreorder() ? [...(this.cfg.pureImages || []), ...neutral] : [...mine, ...neutral];
    }

    /* ---------- Inhaltsstoffe kurz (16.10.2026): Hauptwirkstoffe + Duft, Link zur vollen INCI-Liste unter „Über …“ ---------- */
    renderIngr() {
      const t = this.t;
      const type = this.state.type;
      const key = type === 'BP30' ? 'BP' : familyOf(type);
      const box = this.querySelector('[data-mk-ingr]');
      const hasInci = Boolean(this.inciHtml());
      // Karte: Wirkstoffe als Zeile, Merkmale (Duft, vegan) als Pills, „Alle Inhaltsstoffe“ öffnet ein Pop-up
      // (16.10.2026, Maui: nicht nach unten wegscrollen lassen, sonst bricht man die Konfiguration eher ab)
      const [main, ...tags] = String(t['ingr_' + key] || '').replace(/ E(?=[,\s]|$)/g, '\u00a0E').split(' · '); // „Vitamin E“ nie trennen
      const pureTxt = String(t.ingr_pure || '');
      const ci = pureTxt.indexOf(':');
      const pureHtml = ci > 0
        ? `<span class="mk__ingr-pure-k">${esc(pureTxt.slice(0, ci).trim())}:</span><span class="mk__ingr-pure-v">${esc(pureTxt.slice(ci + 1).trim())}</span>`
        : `<span class="mk__ingr-pure-v">${esc(pureTxt)}</span>`;
      // kompakt (16.10.2026): Wirkstoffe + Merkmale grau + „⊕ Alle Inhaltsstoffe“ in einem Absatz, darunter Pure-Hinweis
      box.innerHTML = `<span class="mk__ingr-main">${esc(main)}${tags.map((x) => ` <span class="mk__ingr-tag">· ${esc(x)}</span>`).join('')}` +
        `${hasInci ? ` <button type="button" class="mk__ingr-all" data-mk-ingr-all aria-haspopup="dialog"><span class="mk__ingr-plus" aria-hidden="true">+</span>${esc(t.ingr_all)}</button>` : ''}</span>` +
        `${key !== 'BP' ? `<button type="button" class="mk__ingr-pure" data-mk-ingr-pure>${pureHtml}<span class="mk__ingr-pure-arrow" aria-hidden="true">→</span></button>` : ''}`;
      const all = box.querySelector('[data-mk-ingr-all]');
      if (all) all.addEventListener('click', () => this.openInci());
      const pure = box.querySelector('[data-mk-ingr-pure]');
      if (pure) pure.addEventListener('click', () => this.setType('BP30'));
    }

    inciHtml() {
      const type = this.state.type;
      return (this.cfg.products[type] && this.cfg.products[type].inci) || (type === 'BP30' ? this.cfg.inciPure : '') || '';
    }

    // Etiketten in echt: Fotos erst beim Öffnen laden, gewähltes Etikett markiert
    openLabels() {
      const dlg = this.querySelector('[data-mk-labels-dlg]');
      dlg.querySelectorAll('img[data-src]').forEach((img) => { if (!img.getAttribute('src')) img.src = img.dataset.src; });
      dlg.querySelectorAll('figure').forEach((f) => f.classList.toggle('is-current', f.dataset.l === this.state.label));
      if (dlg.showModal) dlg.showModal();
      else dlg.setAttribute('open', '');
    }

    openInci() {
      const dlg = this.querySelector('[data-mk-inci]');
      const p = this.cfg.products[this.state.type];
      this.querySelector('[data-mk-inci-prod]').textContent = p ? p.title : 'maligo® Butter Pure';
      this.querySelector('[data-mk-inci-body]').innerHTML = this.inciHtml(); // Shop-eigenes Metafeld (Rich Text)
      // Haltbarkeit nach dem Öffnen (Jelly 12, Butter/Pure 6 Monate)
      const pk = this.state.type === 'BP30' ? 'BP' : familyOf(this.state.type);
      const pao = this.querySelector('[data-mk-inci-pao]');
      pao.hidden = !PAO[pk];
      if (PAO[pk]) { const txt = fill(this.t.pao, { n: PAO[pk] }); pao.textContent = txt.charAt(0).toUpperCase() + txt.slice(1) + '.'; }
      if (dlg.showModal) dlg.showModal();
      else dlg.setAttribute('open', '');
    }

    renderThumbs() {
      const box = this.querySelector('[data-mk-thumbs]');
      // Reihenfolge (17.10.2026): Etikett-Foto · 3D · weitere Fotos · Textur-Video. Start mit dem echten Foto,
      // 3D-Vorschau erst vorne, sobald ein Logo hochgeladen ist (leere „DEIN LOGO“-Dose wirkt wie ein Platzhalter).
      const vid = VIDEOS[(this.state.type || 'J').charAt(0)];
      const pics = this.photos().map((img) => `<button type="button" class="mk__thumb" data-src="${esc(img.src)}"><img src="${esc(img.thumb)}" alt="${esc(img.alt)}" loading="lazy"></button>`);
      box.innerHTML = (pics[0] || '') + `<button type="button" class="mk__thumb mk__thumb--3d" data-src="">${esc(this.t.tab_3d)}</button>` +
        pics.slice(1).join('') +
        (vid ? `<button type="button" class="mk__thumb mk__thumb--video" data-src="${esc(vid.src)}" data-video aria-label="${esc(this.t.video)}"><img src="${esc(vid.poster)}?width=120" alt="" loading="lazy"><span class="mk__play" aria-hidden="true"></span></button>` : '');
      // 19.10.2026: Die vom Kunden gewählte Ansicht (3D, Video oder n-tes Foto) bleibt beim Wechsel von Etikett/Produkt erhalten
      const photoBtns = () => [...box.querySelectorAll('.mk__thumb:not(.mk__thumb--3d):not(.mk__thumb--video)')];
      box.querySelectorAll('.mk__thumb').forEach((b) => b.addEventListener('click', () => {
        this.userView = b.classList.contains('mk__thumb--3d') ? { k: '3d' } : b.hasAttribute('data-video') ? { k: 'video' } : { k: 'photo', i: Math.max(0, photoBtns().indexOf(b)) };
        this.showPhoto(b.dataset.src, b);
      }));
      let keep = null;
      if (this.userView) {
        if (this.userView.k === '3d') keep = box.querySelector('.mk__thumb--3d');
        else if (this.userView.k === 'video') keep = box.querySelector('.mk__thumb--video');
        else keep = photoBtns()[this.userView.i] || photoBtns()[0] || null;
      }
      // Pure: gleich das Foto mit dem Kraft-Tray zeigen (in 3D sähe Pure aus wie die normale Butter)
      const pureFirst = this.isPreorder() && this.cfg.pureImages && this.cfg.pureImages.length ? box.querySelector('.mk__thumb:not(.mk__thumb--3d):not(.mk__thumb--video)') : null;
      const firstPhoto = box.querySelector('.mk__thumb:not(.mk__thumb--3d):not(.mk__thumb--video)');
      if (pureFirst) this.showPhoto(pureFirst.dataset.src, pureFirst);
      else if (keep) this.showPhoto(keep.dataset.src, keep);
      // 20.10.2026 (Maui): Start immer mit dem Produktfoto, auch wenn schon ein Logo gemerkt ist; 3D nur, wenn der Kunde es antippt
      else if (!firstPhoto) this.showPhoto('', box.querySelector('.mk__thumb--3d'));
      else this.showPhoto(firstPhoto.dataset.src, firstPhoto);
    }

    hasLogoImage() {
      return (UPLOADS[this.state.type] || []).some((u) => this.state.images && this.state.images[u.key]);
    }

    showPhoto(src, btn) {
      this.querySelectorAll('.mk__thumb').forEach((b) => b.classList.toggle('is-active', b === btn));
      const photo = this.querySelector('[data-mk-photo]');
      const video = this.querySelector('[data-mk-video]');
      const viewer = this.querySelector('[data-mk-viewer]');
      const isVideo = Boolean(src && btn && btn.hasAttribute('data-video'));
      photo.hidden = !src || isVideo;
      video.hidden = !isVideo;
      viewer.classList.toggle('is-behind', Boolean(src));
      if (!src) this.playSwipe(); // 3D sichtbar: einmal den Dreh-Hinweis zeigen
      if (isVideo) {
        if (video.getAttribute('src') !== src) video.src = src;
        video.play().catch(() => {});
      } else {
        video.pause();
        if (src) photo.src = src;
      }
    }

    update() {
      const t = this.t;
      const v = this.variant();
      const preorder = this.isPreorder();
      this.querySelector('[data-mk-buy]').hidden = preorder;
      this.querySelector('[data-mk-pure]').hidden = !preorder;
      this.classList.toggle('is-preorder', preorder);
      if (preorder) {
        this.querySelector('[data-mk-anchor]').hidden = true;
        this.updateFlip();
        this.updateBar();
        return;
      }

      // Stufen: Ersparnis steht im Vordergrund (Prozent-Abzeichen, Betrag, Extras ab dieser Stufe)
      const tiers = this.tiers();
      const baseExtras = tiers[0] ? this.extras(tiers[0]) : [];
      const maxPct = Math.max(0, ...tiers.filter((x) => x.available).map((x) => this.savingsPct(x)));
      const qtyHint = this.querySelector('[data-mk-qty-hint]');
      qtyHint.hidden = maxPct < 0.01;
      qtyHint.textContent = fill(t.qty_hint, { pct: this.pct(maxPct) });
      this.querySelector('[data-mk-tiers]').innerHTML = tiers.map((x, i) => {
        const pct = this.savingsPct(x);
        const before = i ? this.extras(tiers[i - 1]) : baseExtras;
        const perks = this.extras(x).filter((e) => !before.includes(e) && t['xs_' + e.slice(2)]).map((e) => t['xs_' + e.slice(2)]).map((s) => (s.startsWith('+') ? s : '+ ' + s));
        return `
          <label class="mk__tier ${x.available ? '' : 'is-disabled'} ${pct >= 0.01 ? 'has-save' : ''}">
            <input type="radio" name="mk-tier" value="${x.units}" ${x.units === this.state.units ? 'checked' : ''} ${x.available ? '' : 'disabled'}>
            <span class="mk__tier-main">
              <span class="mk__tier-name">${esc(this.tierName(x.units))}</span>
              <span class="mk__tier-sub">${esc(fill(t.per_unit, { p: this.fmt(x.price / x.units) }))}</span>
            </span>
            <span class="mk__tier-end">
              <span class="mk__tier-price">${x.available ? esc(this.fmt(x.price)) : esc(t.sold_out)}</span>
              ${pct >= 0.01 && x.available ? `<span class="mk__save-pill">−${esc(this.pct(pct))}</span>` : ''}
            </span>
          </label>`;
      }).join('');
      this.querySelectorAll('input[name="mk-tier"]').forEach((el) =>
        el.addEventListener('change', () => this.setUnits(Number(el.value))));

      // Extras + nächste Stufe als Knopf („Mit 2 Trays nur 6,50 € / Stück (−6 %) + Gratisversand“)
      const box = this.querySelector('[data-mk-extras]');
      if (v) {
        const have = this.extras(v);
        const next = tiers.find((x) => x.units > v.units && x.available);
        let nextHtml = `<p class="mk__next is-done">${esc(t.all_extras)}</p>`;
        if (next) {
          const reward = this.extras(next).filter((e) => !have.includes(e)).map((e) => t['xs_' + e.slice(2)] || t[e]);
          const text = fill(t.next2, {
            tier: this.tierName(next.units).split(' · ')[0],
            p: this.fmt(next.price / next.units),
            pct: this.pct(this.savingsPct(next))
          }) + (reward.length ? fill(t.next_plus, { reward: reward.join(', ') }) : '');
          nextHtml = `<button type="button" class="mk__next" data-mk-next="${next.units}"><span>${esc(text)}</span><span aria-hidden="true">→</span></button>`;
        }
        box.innerHTML = `
          <p class="mk__extras-title">${esc(t.included)}</p>
          <ul>${have.map((e) => `<li>${esc(t[e])}</li>`).join('')}</ul>
          ${nextHtml}`;
        const nb = box.querySelector('[data-mk-next]');
        if (nb) nb.addEventListener('click', () => this.setUnits(Number(nb.dataset.mkNext)));
      }

      // Preisanker oben: günstigster Stückpreis dieses Etiketts + Mindestmenge
      const avail = tiers.filter((x) => x.available);
      const anchor = this.querySelector('[data-mk-anchor]');
      anchor.hidden = !avail.length;
      if (avail.length) {
        const best = Math.min(...avail.map((x) => x.price / x.units));
        anchor.innerHTML = `<strong>${esc(fill(t.from_price, { p: this.fmt(best) }))}</strong><span>${esc(t.vat)} · ${esc(fill(t.min_qty, { q: this.tierName(tiers[0].units) }))}</span>`;
      }
      this.querySelector('[data-mk-resp]').hidden = this.state.label === 'DIY';
      this.querySelector('[data-mk-diy-help]').hidden = this.state.label !== 'DIY';

      // UID-Hinweis nur für Firmen in anderen EU-Ländern (Reverse Charge greift nicht in AT, CH ist nicht EU)
      this.querySelector('[data-mk-vat-uid]').hidden = ['AT', 'CH'].includes(this.cfg.country) || !this.cfg.country;

      // „Design per Mail speichern“: nur wenn der Dienst eingerichtet ist und ein Logo-Bild da ist
      this.querySelector('[data-mk-save]').hidden = !(this.cfg.designSaveUrl && this.state.logo === 'upload' && this.hasLogoImage() && this.viewer);

      // Logo-Schritt nur mit Etikett
      this.querySelector('[data-mk-logo-step]').hidden = this.state.label === 'DIY';
      this.querySelector('[data-mk-num-qty]').textContent = this.state.label === 'DIY' ? '2' : '3'; // Produktwahl ist Kopfzeile ohne Nummer; ohne Logo-Schritt rückt die Menge nach
      if (this.state.label === 'DIY') this.querySelectorAll('input[name="mk-logo"]').forEach((el) => (el.checked = false));

      // Summe + Button
      this.querySelector('[data-mk-total]').textContent = v ? this.fmt(v.price) : '–';
      this.querySelector('[data-mk-total-sub]').textContent = v
        ? `${fill(t.units, { n: v.units })} · ${fill(t.per_unit, { p: this.fmt(v.price / v.units) })}`
        : '';
      // Ersparnis zur kleinsten Menge: „−9 % · Du sparst 42,00 €“ links, „statt 459,00 €“ (durchgestrichen) rechts
      const save = v ? this.savings(v) : 0;
      const saveRow = this.querySelector('[data-mk-total-save]');
      saveRow.hidden = !(save > 0 && v.available);
      if (!saveRow.hidden) {
        saveRow.querySelector('[data-mk-save-text]').innerHTML =
          `<span class="mk__save-pill">−${esc(this.pct(this.savingsPct(v)))}</span> ${esc(fill(t.save, { s: this.fmt(save) }))}`;
        saveRow.querySelector('[data-mk-was]').innerHTML = esc(t.was_pre) + `<s>${esc(this.fmt(v.price + save))}</s>`;
      }

      // Werbe-Kit gibt es bei Jelly 12/30 ml und Butter, nie bei 250 ml
      this.querySelector('[data-mk-kit-open]').hidden = this.state.type === 'J250';
      this.updateCalc();
      this.trackConfig();

      // Druckvorlage zur gewählten Dose
      const tpl = TEMPLATES[this.state.type];
      const tplLink = this.querySelector('[data-mk-template]');
      tplLink.hidden = !tpl;
      // Druckvorlage gehört zum Logo; bei Clear/DIY (eigene Sticker) bleibt sie beim Etikett
      if (this.state.label === 'DIY') {
        const diyHelp = this.querySelector('[data-mk-diy-help]');
        if (tplLink.nextElementSibling !== diyHelp) diyHelp.before(tplLink);
      } else {
        const slot = this.querySelector('[data-mk-tpl-slot-logo]');
        if (tplLink.parentElement !== slot) slot.append(tplLink);
      }
      if (tpl) {
        const tl = String(this.cfg.locale).slice(0, 2);
        tplLink.href = CDN + (tpl[tl] || tpl.en) + '?v=' + TPL_V;
        this.querySelector('[data-mk-template-text]').textContent = fill(t.template_text, { product: t['product_' + this.state.type.replace('BP', 'B')] });
      }

      // Solange etwas fehlt, ist der Knopf grau und sagt, was zu tun ist
      const btn = this.querySelector('[data-mk-atc]');
      const missing = this.missing();
      btn.textContent = !v || !v.available ? t.sold_out : missing || t.atc;
      // Fehlt etwas: grau wie gesperrt, aber antippbar → führt zum fehlenden Schritt (statt „nichts passiert“)
      btn.disabled = !v || !v.available;
      btn.classList.toggle('is-missing', Boolean(missing));
      btn.setAttribute('aria-disabled', String(Boolean(missing)));
      this.updateFlip();
      this.updateBar();
    }

    /* ---------- Verdienst-Rechner: eigener Verkaufspreis − Stückpreis der gewählten Menge ---------- */
    updateCalc() {
      const v = this.variant();
      const out = this.querySelector('[data-mk-calc-out]');
      const raw = this.querySelector('[data-mk-calc-price]').value.replace(/[^0-9,.]/g, '').replace(',', '.');
      const sale = Math.round(parseFloat(raw) * 100);
      out.hidden = !v || !(sale > 0);
      if (out.hidden) return;
      const cost = v.price / v.units;
      const profit = sale - cost;
      this.querySelector('[data-mk-calc-cost]').textContent = this.fmt(cost);
      this.querySelector('[data-mk-calc-profit]').textContent = this.fmt(profit);
      this.querySelector('[data-mk-calc-total-label]').textContent = fill(this.t.calc_total, { n: v.units });
      this.querySelector('[data-mk-calc-total]').textContent = this.fmt(profit * v.units);
      out.classList.toggle('is-negative', profit < 0);
    }

    /* ---------- Werbe-Kit ansehen ---------- */
    openKit() {
      const kit = KIT[familyOf(this.state.type)];
      const lang = String(this.cfg.locale).slice(0, 2);
      this.querySelector('[data-mk-kit-steher]').src = `${CDN}${kit.steher[lang] || kit.steher.en}?width=600`;
      this.querySelector('[data-mk-kit-tester]').src = `${CDN}${kit.tester}?width=600`;
      const dlg = this.querySelector('[data-mk-kit]');
      if (dlg.showModal) dlg.showModal();
      else dlg.setAttribute('open', '');
    }

    /* ---------- Voraussichtliche Lieferung bei Bestellung heute (Werktage Mo–Fr) ---------- */
    renderEta() {
      const now = new Date();
      const df = new Intl.DateTimeFormat(this.cfg.locale, { day: 'numeric', month: 'short' });
      const range = ([a, b]) => {
        const from = addWorkdays(now, a);
        const to = addWorkdays(now, b);
        return df.formatRange ? df.formatRange(from, to) : `${df.format(from)} – ${df.format(to)}`;
      };
      this.querySelector('[data-mk-eta]').textContent = fill(this.t.delivery_eta, { at: range(DELIVERY.at), eu: range(DELIVERY.eu) });
    }

    /* ---------- Klaviyo: Konfiguration merken, damit wir angemeldete Studios erinnern können ---------- */
    // Klaviyo ordnet das Ereignis nur bekannten Profilen zu (z. B. nach Klick aus einer Mail oder Anmeldung).
    // Ob eine Mail rausgeht, entscheidet der Flow „Konfigurator abgebrochen“ (nur mit Marketing-Einwilligung).
    trackConfig() {
      const v = this.variant();
      if (!v || !window.klaviyo || this.isPreorder()) return;
      const key = [this.state.type, v.id, this.state.logo].join('|');
      if (key === this.trackedKey) return;
      clearTimeout(this.trackTimer);
      this.trackTimer = setTimeout(() => {
        this.trackedKey = key;
        const p = this.product();
        window.klaviyo.push(['track', 'Konfigurator genutzt', {
          ProductName: p.title,
          Etikett: this.t['label_' + this.state.label],
          Menge: v.units,
          Stueckpreis: Math.round(v.price / v.units) / 100,
          $value: v.price / 100,
          Logo: this.state.logo ? LOGO_VALUES[this.state.logo] : '',
          URL: this.shareUrl(),
          ImageURL: (p.images[0] && p.images[0].src) || ''
        }]);
      }, 2500);
    }

    /* ---------- Mitlaufende Leiste (nur Handy): Summe + Button, sobald die 3D-Vorschau weggescrollt ist ---------- */
    setupBar() {
      this.barSeen = { stage: true, summary: false };
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => (this.barSeen[e.target.dataset.mkWatch] = e.isIntersecting));
        this.showBar();
      });
      const stage = this.querySelector('.mk__stage');
      const summary = this.querySelector('.mk__summary');
      stage.dataset.mkWatch = 'stage';
      summary.dataset.mkWatch = 'summary';
      io.observe(stage);
      io.observe(summary);
    }

    showBar() {
      const bar = this.querySelector('[data-mk-bar]');
      const seen = this.barSeen || { stage: true };
      const show = !seen.stage && !seen.summary && !this.isPreorder() && Boolean(this.variant());
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      bar.querySelector('button').tabIndex = show ? 0 : -1;
      // Shopify-Chat-Knopf (Handy): über die Leiste schieben, beim Gesamtpreis ausblenden (dort steht der WhatsApp-Link)
      document.documentElement.classList.toggle('mk-bar-on', show);
      document.documentElement.classList.toggle('mk-summary-in', Boolean(seen.summary));
    }

    updateBar() {
      const v = this.variant();
      const bar = this.querySelector('[data-mk-bar]');
      if (!bar) return;
      this.showBar();
      if (!v) return;
      bar.querySelector('[data-mk-bar-total]').textContent = this.fmt(v.price);
      const pct = this.savingsPct(v);
      bar.querySelector('[data-mk-bar-sub]').textContent = this.tierName(v.units) + (pct >= 0.01 ? ` · −${this.pct(pct)}` : '');
      const btn = bar.querySelector('button');
      btn.textContent = !v.available ? this.t.sold_out : this.missing() ? this.t.bar_next : this.t.atc;
      btn.disabled = !v.available;
    }

    // fehlt noch etwas (Logo), springt die Leiste dorthin, sonst direkt in den Warenkorb
    barAction() {
      if (!this.missing()) return this.addToCart();
      this.guide();
    }

    // Zum fehlenden Schritt scrollen und ihn kurz hervorheben
    guide() {
      const target = this.state.logo === 'upload' ? this.querySelector('[data-mk-uploads]') : this.querySelector('[data-mk-logo-step]');
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      target.classList.remove('mk__attn');
      void target.offsetWidth;
      target.classList.add('mk__attn');
      setTimeout(() => target.classList.remove('mk__attn'), 1600);
    }

    missing() {
      if (this.state.label === 'DIY') return '';
      if (!this.state.logo) return this.t.atc_need_logo;
      if (this.state.logo === 'upload') {
        const need = UPLOADS[this.state.type].filter((u) => !this.state.files[u.key]);
        if (need.length) return this.t.atc_need_file;
      }
      return '';
    }

    /* ---------- 3D-Vorschau ---------- */
    setupViewer() {
      const box = this.querySelector('[data-mk-viewer]');
      const url = this.dataset.viewerUrl;
      if (!url || !window.WebGLRenderingContext) {
        box.hidden = true;
        return;
      }
      let started = false;
      const start = async () => {
        if (started) return;
        started = true;
        io.disconnect();
        try {
          const mod = await import(url);
          this.viewer = await mod.createViewer(box, {
            type: this.state.type,
            label: this.state.label,
            placeholder: this.t.viewer_placeholder
          });
          this.viewer.onPaint?.(() => this.refreshThumbs());
          this.applyLogos();
          this.querySelector('[data-mk-viewer-hint]').textContent = this.t.viewer_hint;
          this.swipeHint();
          this.updateFlip();
          this.update(); // z. B. „Design per Mail speichern“ braucht die fertige 3D-Ansicht
        } catch (e) {
          console.warn('3D-Vorschau nicht verfügbar', e);
          box.hidden = true;
          const first = this.photos()[0];
          if (first) this.showPhoto(first.src, this.querySelector('.mk__thumb:not(.mk__thumb--3d):not(.mk__thumb--video)'));
        }
      };
      // lädt, sobald die Vorschau ins Bild kommt, spätestens 2 s nach Seitenaufbau
      const io = new IntersectionObserver(([entry]) => entry.isIntersecting && start(), { rootMargin: '200px' });
      io.observe(box);
      setTimeout(start, 2000);
    }

    applyLogos() {
      if (!this.viewer) return;
      this.viewer.setStyle(this.state.label);
      ['lid', 'front', 'side'].forEach((slot) => this.viewer.setLogo(slot, null));
      UPLOADS[this.state.type].forEach((u) => {
        if (this.state.images[u.key]) this.viewer.setLogo(u.key, this.state.images[u.key]);
      });
      this.view = 'top';
      this.updateFlip();
    }

    // Dreh-Hinweis (wie Googles model-viewer): Hand wischt 2× hin und her, dann hoch und runter; die Dose dreht im selben Takt mit.
    // Bei jedem Seitenaufruf, bis zu 3× (alle ~11 s), bis jemand die Dose wirklich dreht (Maui 17.10.2026).
    swipeHint() {
      if (!this.viewer?.onFirstTouch) return;
      this.viewer.onFirstTouch(() => {
        this.swipeUsed = true;
        this.querySelector('[data-mk-swipe]')?.classList.remove('is-on');
        clearTimeout(this.swipeTimer);
      });
      if (!this.querySelector('[data-mk-viewer]').classList.contains('is-behind')) this.playSwipe();
    }

    playSwipe() {
      const el = this.querySelector('[data-mk-swipe]');
      if (!el || !this.viewer?.wiggle || this.swipeUsed || this.swipeRunning || (this.swipePlays || 0) >= 3) return;
      this.swipeRunning = true;
      clearTimeout(this.swipeTimer);
      this.swipeTimer = setTimeout(() => {
        if (this.swipeUsed || this.querySelector('[data-mk-viewer]').classList.contains('is-behind')) { this.swipeRunning = false; return; }
        el.classList.add('is-on');
        this.viewer.wiggle();
        this.swipePlays = (this.swipePlays || 0) + 1;
        this.swipeTimer = setTimeout(() => {
          el.classList.remove('is-on');
          this.swipeRunning = false;
          this.swipeTimer = setTimeout(() => this.playSwipe(), 7000);
        }, 4400);
      }, 700);
    }

    // Ansicht wählen: Vorne · Deckel (von oben) · Hinten (30/250 ml) bzw. Boden (12 ml, Butter)
    flip(view) {
      if (!this.viewer) return;
      this.view = this.viewer.setView(view);
      this.updateFlip();
    }

    updateFlip() {
      const box = this.querySelector('[data-mk-views]');
      if (!this.viewer) {
        box.hidden = true;
        return;
      }
      box.hidden = false;
      const views = ['top', 'front', this.viewer.hasBottomLabel() ? 'bottom' : 'back']; // Deckel zuerst
      const current = this.view || 'top';
      box.innerHTML = views.map((v) => `<button type="button" class="mk__view ${v === current ? 'is-active' : ''}" data-view="${v}" aria-pressed="${v === current}">${esc(this.t['vs_' + v])}</button>`).join('');
      box.querySelectorAll('button').forEach((b) => b.addEventListener('click', () => this.flip(b.dataset.view)));
    }

    /* ---------- Design per Mail speichern (Stufe 2): Vorschaubild → Cloudflare Worker → Shopify-Datei + Klaviyo ---------- */
    async saveDesign() {
      const t = this.t;
      const form = this.querySelector('[data-mk-save-form]');
      const input = this.querySelector('[data-mk-save-email]');
      const msg = this.querySelector('[data-mk-save-msg]');
      const btn = this.querySelector('[data-mk-save-submit]');
      const email = input.value.trim();
      if (!input.checkValidity() || !email) {
        input.reportValidity();
        return;
      }
      btn.disabled = true;
      btn.textContent = t.save_sending;
      msg.hidden = true;
      try {
        // 3D zeigen und kurz warten, damit das Bild die Dose mit Logo zeigt
        this.showPhoto('', this.querySelector('.mk__thumb--3d'));
        await new Promise((r) => setTimeout(r, 450));
        const image = await this.designImage();
        if (!image) throw new Error('kein Bild');
        const v = this.variant();
        const p = this.product();
        const res = await fetch(this.cfg.designSaveUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email,
            newsletter: this.querySelector('[data-mk-save-news]').checked,
            hp: this.querySelector('[data-mk-save-hp]').value,
            image,
            product: p ? p.title : '',
            label: t['label_' + this.state.label],
            units: v ? v.units : 0,
            price: v ? v.price / 100 : 0,
            currency: this.cfg.currency,
            url: this.shareUrl(),
            locale: this.cfg.locale
          })
        });
        const j = await res.json().catch(() => ({}));
        if (!res.ok || !j.ok) throw new Error(j.error || res.status);
        msg.textContent = t.save_ok;
        msg.className = 'mk__save-msg is-ok';
        msg.hidden = false;
        // Erfolg: Eingabefelder weg, nur die Bestätigung bleibt stehen
        form.querySelectorAll('.mk__save-email, .mk__check, .mk__save-privacy, .mk__save-submit').forEach((el) => (el.hidden = true));
        if (window.klaviyo) window.klaviyo.identify({ email });
      } catch (e) {
        console.warn('Design speichern', e);
        msg.textContent = t.save_err;
        msg.className = 'mk__save-msg is-err';
        msg.hidden = false;
        btn.disabled = false;
        btn.textContent = t.save_submit;
      }
    }

    // Vorschaubild als JPEG auf #f7f7f7, längste Seite höchstens 1000 px
    async designImage() {
      if (!this.viewer) return null;
      const blob = await this.viewer.snapshot().catch(() => null);
      if (!blob) return null;
      const bmp = await createImageBitmap(blob);
      const k = Math.min(1, 1000 / Math.max(bmp.width, bmp.height));
      const c = document.createElement('canvas');
      c.width = Math.round(bmp.width * k);
      c.height = Math.round(bmp.height * k);
      const ctx = c.getContext('2d');
      ctx.fillStyle = '#f7f7f7';
      ctx.fillRect(0, 0, c.width, c.height);
      ctx.drawImage(bmp, 0, 0, c.width, c.height);
      return c.toDataURL('image/jpeg', 0.88);
    }

    /* ---------- Teilen: Bild der Dose + Link mit gleicher Auswahl ---------- */
    shareUrl() {
      const p = this.product() || this.shown();
      const url = new URL(p.url, location.origin);
      if (!this.isPreorder()) {
        url.searchParams.set('label', this.state.label);
        url.searchParams.set('units', this.state.units);
      }
      return url.toString();
    }

    // Link öffnen = gleiche Auswahl (?label=GLD&units=54)
    applySharedLink() {
      const q = new URLSearchParams(location.search);
      const label = q.get('label');
      const units = Number(q.get('units'));
      if (label && this.labels().includes(label) && label !== this.state.label) this.setLabel(label);
      if (units && this.tiers().some((v) => v.units === units && v.available)) this.setUnits(units);
    }

    // 3D-Ansicht auf #f7f7f7 legen (sonst transparent → in Messengern schwarz)
    async shareImage() {
      if (!this.viewer || this.querySelector('[data-mk-viewer]').classList.contains('is-behind')) return null;
      const blob = await this.viewer.snapshot().catch(() => null);
      if (!blob) return null;
      const bmp = await createImageBitmap(blob);
      const c = document.createElement('canvas');
      c.width = bmp.width;
      c.height = bmp.height;
      const ctx = c.getContext('2d');
      ctx.fillStyle = '#f7f7f7';
      ctx.fillRect(0, 0, c.width, c.height);
      ctx.drawImage(bmp, 0, 0);
      const out = await new Promise((r) => c.toBlob(r, 'image/png'));
      return out ? new File([out], 'maligo-design.png', { type: 'image/png' }) : null;
    }

    async share() {
      const t = this.t;
      const url = this.shareUrl();
      const title = this.querySelector('[data-mk-title]').textContent;
      const text = t.share_text;
      const file = await this.shareImage();
      // Handy/Mac mit Teilen-Menü: nur das Menü. Abbrechen = keine Meldung, kein Download.
      if (navigator.share) {
        try {
          if (file && navigator.canShare && navigator.canShare({ files: [file] })) {
            await navigator.share({ files: [file], title, text: `${text} ${url}` });
          } else {
            await navigator.share({ title, text, url });
          }
        } catch (e) {
          if (e && e.name === 'AbortError') return; // abgebrochen
          // Menü ließ sich nicht öffnen: nur den Link kopieren
          if (await this.copyLink(url)) this.shareMsg(t.share_link);
        }
        return;
      }
      // Ohne Teilen-Menü (z. B. Firefox am Desktop): Bild speichern + Link kopieren
      if (file) {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(file);
        a.download = file.name;
        a.click();
        setTimeout(() => URL.revokeObjectURL(a.href), 2000);
      }
      const copied = await this.copyLink(url);
      this.shareMsg(file ? (copied ? t.share_both : t.share_img) : (copied ? t.share_link : url));
    }

    async copyLink(url) {
      try {
        await navigator.clipboard.writeText(url);
        return true;
      } catch (e) {
        return false;
      }
    }

    shareMsg(msg) {
      const el = this.querySelector('[data-mk-share-msg]');
      el.textContent = msg;
      el.hidden = false;
      clearTimeout(this.shareTimer);
      this.shareTimer = setTimeout(() => (el.hidden = true), 4000);
    }

    /* ---------- Upload ---------- */
    renderUploads() {
      // „Später per E-Mail“: Adresse erst nach der Auswahl zeigen (hält die Option kurz)
      const later = this.querySelector('[data-mk-later-hint]');
      later.hidden = this.state.logo !== 'later';
      if (!later.hidden) later.innerHTML = esc(this.t.logo_later_hint).replace('print@maligotattoo.com', '<a href="mailto:print@maligotattoo.com">print@maligotattoo.com</a>');
      const wrap = this.querySelector('[data-mk-uploads]');
      const show = this.state.logo === 'upload' && this.state.label !== 'DIY';
      wrap.hidden = !show;
      if (!show) return;
      const t = this.t;
      wrap.innerHTML = UPLOADS[this.state.type].map((u) => `
        <div class="mk__upload" data-key="${u.key}">
          <p class="mk__upload-title">${esc(t['field_' + u.key])}</p>
          <label class="mk__drop">
            <input type="file" accept=".png,.jpg,.jpeg,.pdf,.svg,image/png,image/jpeg,image/svg+xml,application/pdf" hidden>
            <span class="mk__drop-btn">${esc(this.state.files[u.key] ? t.change_file : t.choose_file)}</span>
            <span class="mk__drop-name">${esc(this.state.files[u.key]?.name || t.file_hint)}</span>
          </label>
          <p class="mk__note" data-pdf hidden>${esc(t.preview_pdf)}</p>
          <ul class="mk__warnings" data-warnings></ul>
        </div>`).join('') +
        // Ein einziger Hinweis für alle Logos (Maui 17.10.2026), Pfeil animiert
        `<button type="button" class="mk__to-viewer" data-to-viewer hidden>${esc(t.view_preview.replace(/\s*↑\s*$/, ''))}<span class="mk__to-viewer-arrow" aria-hidden="true">↑</span></button>` +
        `<p class="mk__note">${esc(t.preview_note)} ${esc(t.bleed_hint)}</p>`;
      const toViewer = wrap.querySelector('[data-to-viewer]');
      toViewer.hidden = !Object.keys(this.state.images || {}).some((k) => UPLOADS[this.state.type].some((u) => u.key === k));
      toViewer.addEventListener('click', () => {
        // „Dein Logo auf der Dose ansehen“: bewusst 3D wählen, dann bleibt 3D auch beim Etikett-Wechsel
        this.userView = { k: '3d' };
        this.showPhoto('', this.querySelector('.mk__thumb--3d'));
        this.querySelector('.mk__stage').scrollIntoView({ behavior: 'smooth', block: 'center' });
      });

      UPLOADS[this.state.type].forEach((u) => {
        const box = wrap.querySelector(`[data-key="${u.key}"]`);
        box.querySelector('input').addEventListener('change', (e) => this.onFile(u, e.target.files[0]));
        if (this.state.files[u.key]) this.checkFile(u, this.state.files[u.key]);
      });
    }

    // Mini-Vorschau am Upload-Feld: so sieht das Etikett aus (inkl. Gold/Rainbow auf Schwarz), ohne nach oben zu scrollen (Maui 19.10.2026)
    refreshThumbs() {
      cancelAnimationFrame(this._thumbRaf);
      this._thumbRaf = requestAnimationFrame(() => {
        (UPLOADS[this.state.type] || []).forEach((u) => {
          const drop = this.querySelector(`[data-mk-uploads] [data-key="${u.key}"] .mk__drop`);
          if (!drop) return;
          let c = drop.querySelector('.mk__drop-thumb');
          const img = this.state.images[u.key];
          if (!img || !(img.naturalWidth || img.width)) { if (c) c.remove(); return; }
          const src = this.viewer?.labelCanvas?.(u.key);
          const round = u.key === 'lid';
          const W = round ? 72 : 112;
          const H = round ? 72 : Math.round(src ? (112 * src.height) / src.width : 46);
          if (!c) { c = document.createElement('canvas'); c.className = 'mk__drop-thumb'; drop.prepend(c); }
          c.classList.toggle('is-round', round);
          const dpr = Math.min(2, window.devicePixelRatio || 1);
          c.width = W * dpr; c.height = H * dpr; c.style.width = W + 'px'; c.style.height = H + 'px';
          const g = c.getContext('2d');
          g.clearRect(0, 0, c.width, c.height);
          if (src) g.drawImage(src, 0, 0, c.width, c.height);
          else {
            const iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height;
            const s = Math.min(c.width / iw, c.height / ih);
            g.drawImage(img, (c.width - iw * s) / 2, (c.height - ih * s) / 2, iw * s, ih * s);
          }
        });
      });
    }

    async onFile(u, file) {
      if (!file) return;
      this.state.files[u.key] = file;
      logoSave(u.key, file);
      const box = this.querySelector(`[data-key="${u.key}"]`);
      box.querySelector('.mk__drop-btn').textContent = this.t.change_file;
      box.querySelector('.mk__drop-name').textContent = file.name;
      await this.checkFile(u, file);
      this.update();
    }

    async checkFile(u, file) {
      const box = this.querySelector(`[data-key="${u.key}"]`);
      if (!box) return;
      const warnings = box.querySelector('[data-warnings]');
      warnings.innerHTML = '';
      const isPdf = file.type === 'application/pdf' || /\.pdf$/i.test(file.name);
      box.querySelector('[data-pdf]').hidden = !isPdf;
      if (isPdf) return;
      const img = new Image();
      // auf das Laden warten (decode() hängt in manchen Browsern bei gemerkten Dateien), höchstens 4 s
      await new Promise((done) => {
        img.onload = img.onerror = done;
        setTimeout(done, 4000);
        img.src = URL.createObjectURL(file);
      });
      this.state.images[u.key] = img;
      this.refreshThumbs();
      if (this.viewer) {
        this.viewer.setLogo(u.key, img);
        const toViewer = this.querySelector('[data-mk-uploads] [data-to-viewer]');
        if (toViewer && toViewer.hidden) { toViewer.hidden = false; toViewer.classList.remove('is-new'); void toViewer.offsetWidth; toViewer.classList.add('is-new'); }
        // keine automatische Umschaltung auf 3D (auch nicht beim Laden gemerkter Logos): die gewählte Ansicht bleibt
      }
      this.update();
      const isSvg = file.type === 'image/svg+xml' || /\.svg$/i.test(file.name);
      if (isSvg) return;
      const warn = [];
      if (img.naturalWidth && img.naturalWidth < u.min) {
        warn.push(fill(this.t.warn_res, { w: img.naturalWidth, h: img.naturalHeight, min: u.min }));
      }
      if ((this.state.label === 'GLD' || this.state.label === 'RAI') && this.isColored(img)) {
        warn.push(fill(this.t.warn_color, { label: this.t['label_' + this.state.label] }));
      }
      warnings.innerHTML = warn.map((w) => `<li>${esc(w)}</li>`).join('');
    }

    isColored(img) {
      const c = document.createElement('canvas');
      c.width = 64;
      c.height = 64;
      const ctx = c.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, 64, 64);
      const d = ctx.getImageData(0, 0, 64, 64).data;
      let colored = 0;
      let counted = 0;
      for (let i = 0; i < d.length; i += 4) {
        if (d[i + 3] < 128) continue;
        counted++;
        const max = Math.max(d[i], d[i + 1], d[i + 2]);
        const min = Math.min(d[i], d[i + 1], d[i + 2]);
        if (max - min > 40) colored++;
      }
      return counted > 0 && colored / counted > 0.05;
    }

    /* ---------- Warenkorb ---------- */
    async addToCart() {
      const v = this.variant();
      if (!v || this.missing()) return;
      const err = this.querySelector('[data-mk-error]');
      err.hidden = true;
      this.setBusy(true);

      const fd = new FormData();
      fd.append('id', v.id);
      fd.append('quantity', 1);
      if (this.state.label !== 'DIY') {
        fd.append('properties[_Logo]', LOGO_VALUES[this.state.logo]);
        if (this.state.logo === 'upload') {
          UPLOADS[this.state.type].forEach((u) => fd.append(`properties[${u.prop}]`, this.state.files[u.key]));
        }
      }
      if (this.querySelector('[data-mk-featured]').checked) fd.append('properties[_Fotos teilen erlaubt]', 'Ja');
      const insta = this.querySelector('[data-mk-insta]').value.trim();
      if (insta) fd.append('properties[_Instagram]', insta);
      // 3D-Ansicht als Bild an die Bestellung (für den Datencheck), nur wenn ein Logo hochgeladen wurde
      if (this.viewer && this.state.logo === 'upload') {
        const shot = await this.viewer.snapshot().catch(() => null);
        if (shot) fd.append('properties[_Vorschau 3D]', new File([shot], 'vorschau-3d.png', { type: 'image/png' }));
      }

      let added = false;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { Accept: 'application/json', 'X-Maligo-Probe': '1' }
        });
        if (!res.ok) throw new Error((await res.json()).description || res.status);
        added = true;
        // Haken sofort zeigen; Gratis-Probe und Warenkorb-Schublade laufen im Hintergrund, die Schublade kommt erst nach dem Haken
        this.showAdded();
        const shown = new Promise((r) => setTimeout(r, 900));
        if (window.maligoProbes) await window.maligoProbes.sync().catch(() => {});
        await shown;
        if (window.maligoProbes) await window.maligoProbes.refreshCart().catch(() => {});
        else location.href = '/cart';
        document.dispatchEvent(new CustomEvent('afterCartChanged', { detail: { productVariantId: v.id, source: 'maligo-konfigurator' } }));
      } catch (e) {
        console.error(e);
        if (!added) {
          err.textContent = this.t.error;
          err.hidden = false;
        }
      } finally {
        if (!added) {
          this.setBusy(false);
          this.update();
        }
      }
    }

    // Während des Hinzufügens: Knopf bleibt schwarz, kleiner Lade-Kreis statt grauem „gesperrt“-Knopf
    setBusy(on) {
      [this.querySelector('[data-mk-atc]'), this.querySelector('[data-mk-bar-btn]')].forEach((b) => {
        b.classList.toggle('is-busy', on);
        b.setAttribute('aria-busy', String(on));
        if (on) {
          b.disabled = true;
          b.innerHTML = `<span class="mk__spinner" aria-hidden="true"></span><span>${esc(this.t.adding)}</span>`;
        }
      });
    }

    // Kurze Bestätigung im Knopf: Haken zeichnet sich, Knopf „ploppt“ leicht, nach 1,8 s wieder normal
    showAdded() {
      const btns = [this.querySelector('[data-mk-atc]'), this.querySelector('[data-mk-bar-btn]')];
      btns.forEach((b) => {
        b.disabled = true;
        b.classList.remove('is-busy');
        b.setAttribute('aria-busy', 'false');
        b.classList.add('is-added');
        b.innerHTML = `<svg class="mk__check-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg><span>${esc(this.t.added)}</span>`;
      });
      clearTimeout(this.addedTimer);
      this.addedTimer = setTimeout(() => {
        btns.forEach((b) => b.classList.remove('is-added'));
        this.update();
      }, 1800);
    }
  }

  customElements.define('maligo-konfigurator', MaligoKonfigurator);
})();
